var cov_i6izc75y4 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Pagination/Pagination.tsx",
      hash = "ef8021b8c2aef1081f5ac2418fdf8cb714bbd2b0",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Pagination/Pagination.tsx",
    statementMap: {
      "0": {
        start: {
          line: 14,
          column: 21
        },
        end: {
          line: 19,
          column: 1
        }
      },
      "1": {
        start: {
          line: 25,
          column: 43
        },
        end: {
          line: 25,
          column: 53
        }
      },
      "2": {
        start: {
          line: 27,
          column: 16
        },
        end: {
          line: 27,
          column: 23
        }
      },
      "3": {
        start: {
          line: 29,
          column: 22
        },
        end: {
          line: 29,
          column: 103
        }
      },
      "4": {
        start: {
          line: 31,
          column: 29
        },
        end: {
          line: 31,
          column: 74
        }
      },
      "5": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 57,
          column: 5
        }
      },
      "6": {
        start: {
          line: 36,
          column: 10
        },
        end: {
          line: 54,
          column: 11
        }
      },
      "7": {
        start: {
          line: 38,
          column: 14
        },
        end: {
          line: 38,
          column: 74
        }
      },
      "8": {
        start: {
          line: 40,
          column: 14
        },
        end: {
          line: 40,
          column: 88
        }
      },
      "9": {
        start: {
          line: 42,
          column: 14
        },
        end: {
          line: 42,
          column: 76
        }
      },
      "10": {
        start: {
          line: 44,
          column: 14
        },
        end: {
          line: 44,
          column: 61
        }
      },
      "11": {
        start: {
          line: 46,
          column: 14
        },
        end: {
          line: 52,
          column: 15
        }
      },
      "12": {
        start: {
          line: 47,
          column: 16
        },
        end: {
          line: 51,
          column: 17
        }
      },
      "13": {
        start: {
          line: 53,
          column: 14
        },
        end: {
          line: 53,
          column: 25
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 24,
            column: 3
          }
        },
        loc: {
          start: {
            line: 24,
            column: 11
          },
          end: {
            line: 58,
            column: 3
          }
        },
        line: 24
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 35,
            column: 21
          },
          end: {
            line: 35,
            column: 22
          }
        },
        loc: {
          start: {
            line: 35,
            column: 37
          },
          end: {
            line: 55,
            column: 9
          }
        },
        line: 35
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 29,
            column: 67
          },
          end: {
            line: 29,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 29,
            column: 67
          },
          end: {
            line: 29,
            column: 70
          }
        }, {
          start: {
            line: 29,
            column: 74
          },
          end: {
            line: 29,
            column: 79
          }
        }],
        line: 29
      },
      "1": {
        loc: {
          start: {
            line: 36,
            column: 10
          },
          end: {
            line: 54,
            column: 11
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 37,
            column: 12
          },
          end: {
            line: 38,
            column: 74
          }
        }, {
          start: {
            line: 39,
            column: 12
          },
          end: {
            line: 40,
            column: 88
          }
        }, {
          start: {
            line: 41,
            column: 12
          },
          end: {
            line: 42,
            column: 76
          }
        }, {
          start: {
            line: 43,
            column: 12
          },
          end: {
            line: 44,
            column: 61
          }
        }, {
          start: {
            line: 45,
            column: 12
          },
          end: {
            line: 53,
            column: 25
          }
        }],
        line: 36
      },
      "2": {
        loc: {
          start: {
            line: 46,
            column: 14
          },
          end: {
            line: 52,
            column: 15
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 14
          },
          end: {
            line: 52,
            column: 15
          }
        }, {
          start: {
            line: 46,
            column: 14
          },
          end: {
            line: 52,
            column: 15
          }
        }],
        line: 46
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0, 0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Pagination/Pagination.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { defaultProps } from '../utils/defaultProps';
import { paginationClass } from './styles';
import Links from './Links';
import Jumper from './Jumper';
import Simple from './Simple';
import PageSizeList from './PageSizeList';
import { isRTL } from '../config';
import getDataset from '../utils/dom/getDataset';
import { getDirectionClass } from '../utils/classname';
var DefaultValue = (cov_i6izc75y4.s[0]++, _objectSpread2(_objectSpread2({}, defaultProps), {}, {
  layout: ['links'],
  span: 5,
  text: {}
}));

var Pagination =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Pagination, _PureComponent);

  var _super = _createSuper2(Pagination);

  function Pagination() {
    _classCallCheck(this, Pagination);

    return _super.apply(this, arguments);
  }

  _createClass(Pagination, [{
    key: "render",
    value: function render() {
      var _this = this;

      cov_i6izc75y4.f[0]++;

      var _ref = (cov_i6izc75y4.s[1]++, this.props),
          align = _ref.align,
          layout = _ref.layout,
          size = _ref.size,
          style = _ref.style;

      var rtl = (cov_i6izc75y4.s[2]++, isRTL());
      var className = (cov_i6izc75y4.s[3]++, classnames(paginationClass('_', size, align, (cov_i6izc75y4.b[0][0]++, rtl) && (cov_i6izc75y4.b[0][1]++, 'rtl')), this.props.className));
      var sectionClassName = (cov_i6izc75y4.s[4]++, paginationClass(getDirectionClass('section')));
      cov_i6izc75y4.s[5]++;
      return (
        /*#__PURE__*/
        React.createElement("div", Object.assign({
          className: className,
          style: style
        }, getDataset(this.props), {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 34,
            columnNumber: 7
          }
        }), layout.map(function (section, i) {
          cov_i6izc75y4.f[1]++;
          cov_i6izc75y4.s[6]++;

          switch (section) {
            case 'links':
              cov_i6izc75y4.b[1][0]++;
              cov_i6izc75y4.s[7]++;
              return (
                /*#__PURE__*/
                React.createElement(Links, Object.assign({
                  key: section
                }, _this.props, {
                  __self: _this,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 38,
                    columnNumber: 22
                  }
                }))
              );

            case 'list':
              cov_i6izc75y4.b[1][1]++;
              cov_i6izc75y4.s[8]++;
              return (
                /*#__PURE__*/
                React.createElement(PageSizeList, Object.assign({
                  key: section
                }, _this.props, {
                  __self: _this,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 40,
                    columnNumber: 22
                  }
                }))
              );

            case 'jumper':
              cov_i6izc75y4.b[1][2]++;
              cov_i6izc75y4.s[9]++;
              return (
                /*#__PURE__*/
                React.createElement(Jumper, Object.assign({
                  key: section
                }, _this.props, {
                  __self: _this,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 42,
                    columnNumber: 22
                  }
                }))
              );

            case 'simple':
              cov_i6izc75y4.b[1][3]++;
              cov_i6izc75y4.s[10]++;
              return (
                /*#__PURE__*/
                React.createElement(Simple, Object.assign({
                  key: section
                }, _this.props, {
                  __self: _this,
                  __source: {
                    fileName: _jsxFileName,
                    lineNumber: 44,
                    columnNumber: 22
                  }
                }))
              );

            default:
              cov_i6izc75y4.b[1][4]++;
              cov_i6izc75y4.s[11]++;

              if (typeof section === 'function') {
                cov_i6izc75y4.b[2][0]++;
                cov_i6izc75y4.s[12]++;
                return (
                  /*#__PURE__*/
                  React.createElement("div", {
                    key: i,
                    className: sectionClassName,
                    __self: _this,
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 48,
                      columnNumber: 19
                    }
                  },
                  /*#__PURE__*/
                  React.createElement("span", {
                    __self: _this,
                    __source: {
                      fileName: _jsxFileName,
                      lineNumber: 49,
                      columnNumber: 21
                    }
                  }, section(_this.props)))
                );
              } else {
                cov_i6izc75y4.b[2][1]++;
              }

              cov_i6izc75y4.s[13]++;
              return null;
          }
        }))
      );
    }
  }]);

  return Pagination;
}(PureComponent);

Pagination.defaultProps = DefaultValue;
export default Pagination;